import React, {Component} from 'react'
import {Modal, Select, Form, Icon, Divider, Badge, Button} from 'antd'
import Promise from 'bluebird'
import classNames from "classnames"
import {Redirect} from 'react-router-dom'
import Files from "react-butterfiles"
import {labelUploadParse} from "../../../services/api/labelApi"

const {Option} = Select

class ImportLabelsPDFModal extends Component {
    state = {
        carrier: '',
        files: [],
        errors: [],
        itemsSuccess: [],
        itemError: [],
        itemLoading: '',
        error: ''
    }

    _handleChangeCarrier = (value) => {
        this.setState({
            carrier: value
        })
    }

    _handleSelectedFiles = (files) => {
        this.setState({
            files
        }, () => {
            this._bulkUploadFiles(files)
        })
    }

    _bulkUploadFiles = async (files) => {
        await Promise.each(files, async item => {
            this.setState({
                itemLoading: item.id
            })

            await this._handleUploadFile(item)
        })
    }

    _handleUploadFile = async (item) => {
        let {itemError, itemsSuccess, files, carrier} = this.state
        const total = itemsSuccess.length > 0 ? (files.length + itemsSuccess.length) : files.length

        this.setState({
            error: ''
        })

        try {
            const file = item.src.file
            const formData = new FormData()

            formData.append('label_pdf', file)
            formData.append('shipping_carrier', carrier === 'royal_mail_2' ? 'royal_mail' : carrier)

            if (carrier === 'royal_mail_2') {
                formData.append('meta[is_2_pages]', 1)
            }

            const {data: response} = await labelUploadParse(formData)

            const {data, success, error} = response

            if (success) {
                itemsSuccess.push({
                    id: item.id,
                    status: data.status
                })

                return this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item.id
                })
            } else {
                itemError.push({
                    id: item.id,
                    file: item,
                    status: 'error',
                    message: error
                })

                this.setState({
                    itemError: itemError,
                    itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item.id
                })
            }
        } catch (e) {
            itemError.push({
                id: item.id,
                file: item,
                status: 'error',
                message: e.message
            })

            this.setState({
                itemError: itemError,
                itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item.id
            })
        }
    }

    _retryAll = async () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        await Promise.each(itemError, async item => {
            this.setState({
                itemLoading: item.id
            })

            await this._handleUploadFile(item.file)
        })
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsError = itemError.map(item2 => {
            if (item2.id === item.id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })

        this.setState({
            itemError: newItemsError,
            itemLoading: item.id
        })

        this._handleUploadFile(item)
    }

    _handleSelectedError = (errors) => {
        this.setState({
            errors
        })
    }

    _showMessage = (itemError, itemsSuccess, id) => {
        const {itemLoading} = this.state

        if (itemError.find(itemErr => id === itemErr.id) !== undefined) {
            if (itemError.find(itemErr => id === itemErr.id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => id === itemErr.id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">{itemLoading === id ? 'Đang đẩy' : 'Đang chờ'} ...</span>
                )
            }
        } else if (itemsSuccess.find(item => item.id === id)) {
            return (
                <span className="d-sm-block text-success">Đẩy file thành công, chờ hệ thống xử lý!</span>
            )
        } else {
            return (
                <span className="d-sm-block">{itemLoading === id ? 'Đang đẩy' : 'Đang chờ'} ...</span>
            )
        }
    }

    _handleDeleteItem = (file) => {
        const {files} = this.state
        this.setState({
            files: files.filter(item => item.id !== file.id)
        })
    }

    _handleClosePopup = () => {
        const {onClose} = this.props
        this.setState({
            carrier: '',
            files: [],
            errors: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: '',
            error: ''
        }, () => {
            onClose()
        })
    }

    _getClass = (status) => {
        return classNames({
            'pending': status === 'pending',
            'processing progress-bar-animated progress-bar-striped': status === 'processing',
            'failed': status === 'failed',
            'cancelled': status === 'cancelled',
            'completed': status === 'done',
        })
    }

    render() {
        const {isOpen} = this.props
        const {carrier, files, itemError, itemsSuccess, itemLoading, error, errors} = this.state

        return (
            <Modal
                title="Upload file labels"
                closable={false}
                width={800}
                visible={isOpen}
                onOk={this._handleClosePopup}
                footer={[
                    <Button key="retry" type="danger" disabled={itemError.length === 0} onClick={this._retryAll}>
                        Import lại
                    </Button>,
                    <Button key="submit" type="primary" onClick={this._handleClosePopup}>
                        Đóng
                    </Button>,
                ]}
            >
                <Form.Item label="Chọn Shipping carrier:">
                    <Select disabled={itemLoading !== ''} value={carrier} onChange={this._handleChangeCarrier}
                            placeholder="Chọn Shipping carrier">
                        <Option value="">--- Chọn carrier ---</Option>
                        <Option value="royal_mail">Royal Mail 1 page</Option>
                        <Option value="royal_mail_2">Royal Mail 2 pages</Option>
                        <Option value="singapore_post">Singapore Post</Option>
                        <Option value="timus">TimUS</Option>
                        <Option value="ups_uk">UPS</Option>
                        <Option value="usps_mn">USPS MN</Option>
                        <Option value="dailydesign">Daily Design</Option>
                        <Option value="flashship_usps_manual">LLC_manual</Option>
                        <Option value="dpd_uk">DPD UK</Option>
                        <Option value="sb_ca">SB CA</Option>
                        <Option value="sb_au">SB AU</Option>
                        <Option value="sb_yun_express">SB-YUN</Option>
                        <Option value="hw_usps">HW_USPS</Option>
                        <Option value="jt_usps">JT_USPS</Option>
                        <Option value="ns_usps">NS_USPS</Option>
                        <Option value="ge_dhl">ITC Standard</Option>
                        <Option value="itc_spx">ITC SPX</Option>
                        <Option value="itc_gofo">ITC GOFO</Option>
                    </Select>
                </Form.Item>
                {
                    carrier && (
                        <Form.Item disabled label="Chọn hoặc kéo thả file:">
                            <Files
                                multiple={true}
                                maxSize="100mb"
                                multipleMaxSize="1000mb"
                                multipleMaxCount={20}
                                accept={["application/pdf"]}
                                onSuccess={this._handleSelectedFiles}
                                onError={this._handleSelectedError}
                            >
                                {({browseFiles, getDropZoneProps}) => (
                                    <>
                                        <div className="boxUploadFile"
                                             onClick={itemLoading === '' ? browseFiles : undefined} {...getDropZoneProps({
                                            style: {
                                                width: "100%",
                                                minHeight: 300,
                                                background: "rgb(247 247 247)",
                                                border: "2px lightgray dashed"
                                            }
                                        })}>
                                            <div className="iconPDF">
                                                <Icon type="file-pdf"/>
                                                <span className="mt-3 font-18 font-weight-bold">Chọn hoặc kéo thả file vào đây!</span>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Files>
                        </Form.Item>
                    )
                }
                {
                    error && <div className="text-danger mb-3">{error}</div>
                }
                {
                    errors.length > 0 && errors.map((item, index) => (
                        <div key={index} className="text-danger mb-3">{item}</div>
                    ))
                }
                {
                    (files.length > 0) && (
                        <div className="listFileProgress">
                            <ul>
                                {files.map((file, index) => {
                                    const isSuccess = itemsSuccess.find(itemSucc => file.id === itemSucc.id)
                                    const isError = itemError.find(itemErr => file.id === itemErr.id)
                                    return (
                                        <li key={file.name}>
                                            <div className="d-flex justify-content-between">
                                                <span className="font-weight-bold">{index + 1}. {file.name}</span>
                                                <span className="d-flex align-items-center">
                                                {
                                                    (isError !== undefined) && (
                                                        <Badge
                                                            count="Lỗi"
                                                            style={{backgroundColor: '#ff3700', color: '#ffffff'}}
                                                        />
                                                    )
                                                }
                                                    {
                                                        isSuccess !== undefined && (
                                                            <span
                                                                className={`badge ${this._getClass(isSuccess.status)} badge-pill`}>{isSuccess.status}</span>
                                                        )
                                                    }
                                                    {
                                                        (isError === undefined && isSuccess === undefined && itemLoading !== file.id) && (
                                                            <Icon onClick={() => this._handleDeleteItem(file)}
                                                                  className="ml-2" type="close-circle"/>
                                                        )
                                                    }
                                            </span>
                                            </div>
                                            <div className="ContentChangeStatus d-flex align-items-center">
                                                {
                                                    (isError !== undefined && itemLoading !== file.id) && (
                                                        <span onClick={() => this._handleClickRetryItem(file)}>
                                                            <Icon className="text-danger mr-2 cursor-pointer"
                                                                  type="redo"/>
                                                        </span>
                                                    )
                                                }
                                                {itemLoading === file.id && <Icon className="mr-2" type="sync" spin/>}
                                                {this._showMessage(itemError, itemsSuccess, file.id)}
                                            </div>
                                            <Divider style={{marginTop: 12, marginBottom: 12}} dashed/>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    )
                }
                {(files.length > 0 && files.length === itemsSuccess.length) && <Redirect to='/list-job-labels'/>}
            </Modal>
        )
    }
}

export default ImportLabelsPDFModal
